import React from 'react';
import { getEarlyDeparture } from '../../services/timesheetService';
import PresetReportPage from './components/PresetReportPage';

// AKM POC §5.15 / §7 — Devam Paneli'nden panel süzgeçleriyle açılabilir; ortak süzgeç seti, TA ekip kapsamı ve sunucu
// tarafı Excel / PDF dışa aktarma ortak gövdede (PresetReportPage).
export default function EarlyDeparturePage() {
  return <PresetReportPage fetchFn={getEarlyDeparture} titleKey="pdks.earlyDepartureTitle" exportUrl="/v1/ta/reports/early-departure/export" />;
}
